module.exports = __webpack_public_path__ + "static/media/power2x.9362d936.jpg";